// Building block labels and metadata
// Ported from the prototype's shared/schema.ts

export const BUILDING_BLOCK_LABELS: Record<string, { number: number; label: string; description: string }> = {
  vision: {
    number: 1,
    label: "Vision",
    description: "Your Vision paints a picture of the world you're working to create — the impact beyond your company walls.",
  },
  mission: {
    number: 2,
    label: "Mission",
    description: "What the company does and for whom, today.",
  },
  peakAmbition: {
    number: 3,
    label: "Peak Ambition",
    description: "The world-changing impact + business achievement by a specific future date.",
  },
  peakAmbitionObjectives: {
    number: 4,
    label: "Peak Ambition Objectives",
    description: "What Must Be True (WMBT) to achieve Peak Ambition.",
  },
  threeYearObjectives: {
    number: 5,
    label: "3-Year Objectives",
    description: "WMBT ~3 years out to springboard toward Peak Ambition.",
  },
  oneYearObjectives: {
    number: 6,
    label: "1-Year Objectives",
    description: "WMBT ~1 year out to hit the 3-year springboard.",
  },
  quarterlyObjectives: {
    number: 7,
    label: "Quarterly Objectives",
    description: "WMBT this quarter to hit the 1-year mark.",
  },
};
